"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processItems = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../../utils/big-numbers");
var customizations_1 = require("./customizations");
var mapper_1 = require("./mapper");
var processItems = function (_a) {
    var preprocessedItems = _a.preprocessedItems, digitsRange = _a.digitsRange, _b = _a.parentDepth, parentDepth = _b === void 0 ? -1 : _b, _c = _a.parentPrice, parentPrice = _c === void 0 ? big_numbers_1.big0 : _c;
    var totalShares = preprocessedItems.reduce(function (sum, _a) {
        var productOriginalUnitPrice = _a.productOriginalUnitPrice, quantity = _a.quantity;
        var productOriginalPrice = new bignumber_js_1.default(productOriginalUnitPrice)
            .shiftedBy(digitsRange)
            .multipliedBy(quantity);
        return productOriginalPrice.isGreaterThan(big_numbers_1.big0) ? sum.plus(productOriginalPrice) : sum;
    }, big_numbers_1.big0);
    var totalAmount = big_numbers_1.big0;
    var currentDepth = parentDepth + 1;
    var reportedShare = big_numbers_1.big0;
    var processedItems = preprocessedItems.reduce(function (processingItems, buildPosOrderItem) {
        var stringProductOriginalUnitPrice = buildPosOrderItem.productOriginalUnitPrice, stringOriginalUnitPrice = buildPosOrderItem.originalUnitPrice, itemDiscount = buildPosOrderItem.itemDiscount, quantity = buildPosOrderItem.quantity, index = buildPosOrderItem.index, childItems = buildPosOrderItem.childItems, _a = buildPosOrderItem.customizations, customizations = _a === void 0 ? [] : _a;
        // 1. itemAmount
        // 1.a parent part
        var productOriginalPrice = new bignumber_js_1.default(stringProductOriginalUnitPrice)
            .shiftedBy(digitsRange)
            .multipliedBy(quantity);
        var share = bignumber_js_1.default.max(productOriginalPrice, big_numbers_1.big0);
        var parentProductAmountShare = share.absoluteValue().multipliedBy(parentPrice).plus(reportedShare);
        var itemAmountParentPart = totalShares.isZero()
            ? big_numbers_1.big0
            : parentProductAmountShare.dividedToIntegerBy(totalShares);
        reportedShare = parentProductAmountShare.minus(itemAmountParentPart.multipliedBy(totalShares));
        // 1.b "extra" part
        var originalPrice = new bignumber_js_1.default(stringOriginalUnitPrice).shiftedBy(digitsRange).multipliedBy(quantity);
        var preprocessedCustomizations = (0, customizations_1.preprocessCustomizations)(customizations, digitsRange);
        var itemPrice = new bignumber_js_1.default(buildPosOrderItem.totalPriceWithTaxIncluded).shiftedBy(digitsRange);
        preprocessedCustomizations.forEach(function (_a) {
            var preprocessedTotalPrice = _a.preprocessedTotalPrice;
            itemPrice = itemPrice.minus(preprocessedTotalPrice.multipliedBy(quantity));
        });
        var itemAmountExtraPart = bignumber_js_1.default.max(itemPrice, originalPrice);
        var itemAmount = itemAmountParentPart.plus(itemAmountExtraPart);
        // 2. share itemAmount on child items
        var _b = (0, exports.processItems)({
            preprocessedItems: childItems,
            digitsRange: digitsRange,
            parentDepth: currentDepth,
            parentPrice: itemAmount,
        }), childrenProcessedItems = _b.processedItems, childrenTotalAmount = _b.totalAmount, parentAmountIsSharedOnProducts = _b.parentAmountIsSharedOnProducts;
        itemAmount = parentAmountIsSharedOnProducts ? big_numbers_1.big0 : itemAmount;
        // 3. share itemAmount on customization
        var _c = (0, customizations_1.processCustomizations)({
            preprocessedCustomizations: preprocessedCustomizations,
            parentProductAmount: itemAmount,
            parentQuantity: +quantity,
            parentIndex: index,
            parentDepth: currentDepth,
            digitsRange: digitsRange,
        }), processedCustomizations = _c.processedCustomizations, customizationsTotalAmount = _c.customizationsTotalAmount, parentAmountIsSharedOnCustomizations = _c.parentAmountIsSharedOnCustomizations;
        itemAmount = parentAmountIsSharedOnCustomizations ? big_numbers_1.big0 : itemAmount;
        var totalItemAmount = itemAmount.plus(childrenTotalAmount).plus(customizationsTotalAmount);
        totalAmount = totalAmount.plus(totalItemAmount);
        var discountedAmount = totalItemAmount
            .minus(new bignumber_js_1.default(itemDiscount || 0).shiftedBy(digitsRange))
            .integerValue();
        itemAmount = discountedAmount.lt(0) ? discountedAmount : itemAmount;
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], processingItems, true), [
            (0, mapper_1.posOrderItemToOrderDetailProductMapper)(buildPosOrderItem, itemAmount, currentDepth)
        ], false), processedCustomizations, true), childrenProcessedItems, true);
    }, []);
    return { processedItems: processedItems, totalAmount: totalAmount, parentAmountIsSharedOnProducts: !totalShares.isZero() };
};
exports.processItems = processItems;
